import type { CommentableContentObject, ContentObjectDetail, ContentObjectList } from 'models';

export const createCommentContentObject = (
  item: ContentObjectDetail | ContentObjectList,
): CommentableContentObject | undefined => {
  if (item.type === 'comment' || item.type === 'video') {
    return undefined;
  }

  if (item.contentableType === 'Community') {
    return {
      contentableType: 'Community',
      id: item.id,
      organization: item.organization,
      postInCommunities: item.postInCommunities,
      type: item.type,
    };
  }

  if (item.contentableType === 'Program') {
    return item;
  }

  return undefined;
};
